// Preencher toda vez que tiver nova atualização
export const controlVersion = {
  version: 'v4.5.35',
  messages: [
    'Fizemos algumas manutenções para o sistema ficar ainda mais rápido e fácil de usar.'
  ]
};

